import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Facebook } from "lucide-react";
import api from "@/lib/api";
import VisitorStats from "@/components/VisitorStats";

const LOGO_URL = "/logo.png";

export const Footer = () => {
    const [author, setAuthor] = useState("Projekt i wykonanie: Michał Skarżyński");
    const [copyright, setCopyright] = useState(
        `© ${new Date().getFullYear()} Wspólnota Mieszkaniowa Dąbrówka Wiślana. Wszystkie prawa zastrzeżone.`
    );
    const [adminEmail, setAdminEmail] = useState("portal@aluzyjna25cdef.pl");

    useEffect(() => {
        api.get("/settings")
            .then((r) => {
                if (r.data?.footer_author) setAuthor(r.data.footer_author);
                if (r.data?.footer_copyright) {
                    setCopyright(
                        String(r.data.footer_copyright).replace(/\{year\}/g, new Date().getFullYear())
                    );
                }
                if (r.data?.site_admin_email) setAdminEmail(r.data.site_admin_email);
            })
            .catch(() => {});
    }, []);

    return (
        <footer data-testid="site-footer" className="bg-[#092E22] text-white/90 pt-20 pb-8">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid md:grid-cols-4 gap-12 mb-12">
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-4 mb-5">
                            <img src={LOGO_URL} alt="Dąbrówka Wiślana" className="h-14 w-14 rounded-full ring-2 ring-[#D4A537]/50" />
                            <div>
                                <h3 className="font-serif text-2xl text-white">Dąbrówka Wiślana</h3>
                                <p className="text-[#D4A537] text-xs tracking-[0.3em] uppercase">Aluzyjna 25 C/D/E/F</p>
                            </div>
                        </div>
                        <p className="text-white/70 max-w-md leading-relaxed text-sm">
                            Wspólnota mieszkaniowa na warszawskiej Białołęce. Tworzymy przestrzeń,
                            w której sąsiedztwo łączy się z komfortem i bezpieczeństwem.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-serif text-[#D4A537] text-lg mb-4">Szybkie menu</h4>
                        <ul className="space-y-2 text-sm">
                            <li><a href="/#komunikaty" className="hover:text-[#D4A537] transition-colors" data-testid="footer-link-komunikaty">Komunikaty</a></li>
                            <li><a href="/#wiadomosci" className="hover:text-[#D4A537] transition-colors" data-testid="footer-link-wiadomosci">Wiadomości</a></li>
                            <li><a href="/#uchwaly" className="hover:text-[#D4A537] transition-colors" data-testid="footer-link-uchwaly">Uchwały</a></li>
                            <li><Link to="/ogloszenia" className="hover:text-[#D4A537] transition-colors" data-testid="footer-link-ogloszenia">Ogłoszenia mieszkańców</Link></li>
                            <li><Link to="/mapa" className="hover:text-[#D4A537] transition-colors" data-testid="footer-link-mapa">Mapa osiedla</Link></li>
                            <li><a href="/#kontakt" className="hover:text-[#D4A537] transition-colors" data-testid="footer-link-kontakt">Kontakt</a></li>
                            <li><Link to="/zglos-usterke" className="hover:text-[#D4A537] transition-colors" data-testid="footer-link-report">Zgłoś usterkę</Link></li>
                            <li><Link to="/polityka-prywatnosci" className="hover:text-[#D4A537] transition-colors" data-testid="footer-link-privacy">Polityka prywatności</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-serif text-[#D4A537] text-lg mb-4">Kontakt</h4>
                        <ul className="space-y-3 text-sm text-white/80">
                            <li className="flex items-start gap-2">
                                <MapPin size={16} className="mt-0.5 text-[#D4A537] shrink-0" />
                                <span>ul. Aluzyjna 25 C/D/E/F<br />03-149 Warszawa, Białołęka</span>
                            </li>
                            <li className="flex items-center gap-2">
                                <Mail size={16} className="text-[#D4A537] shrink-0" />
                                <a href={`mailto:${adminEmail}`} className="hover:text-[#D4A537]" data-testid="footer-email">
                                    {adminEmail}
                                </a>
                            </li>
                            <li className="flex items-center gap-2">
                                <Facebook size={16} className="text-[#D4A537] shrink-0" />
                                <span>Grupa osiedlowa</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="divider-gold mb-8 opacity-50" />

                <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/60">
                    <p data-testid="footer-copyright" dangerouslySetInnerHTML={{ __html: copyright }} />
                    <p data-testid="footer-author" dangerouslySetInnerHTML={{ __html: author }} />
                </div>
                <VisitorStats />
            </div>
        </footer>
    );
};

export default Footer;
